<script>
/**
 * @overview 全局底部容器逐渐
 *
 * @author huojinzhao
 */

export default {
  name: "TheFooter",
};
</script>

<template>
  <div class="layout-the-footer the-footer">
    <slot/>
  </div>
</template>

<style lang="postcss" scoped>
.the-footer {

}
.layout-the-footer{
  justify-content: center;
}
</style>
